import * as React from "react";
import { Slot } from "@radix-ui/react-slot";
import { cva, type VariantProps } from "class-variance-authority";

import { cn } from "@/lib/utils";

const buttonVariants = cva(
  // Identidade (EST-27): pilula, sem sombra (so no hover); primario escuro com hover na cor da marca.
  "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full text-13 font-semibold transition-all disabled:pointer-events-none disabled:opacity-50 outline-none focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-ring",
  {
    variants: {
      variant: {
        default: "bg-primario text-sobre-primario hover:bg-primario-hover",
        destructive: "bg-destructive text-white hover:shadow-hover",
        outline: "border border-borda bg-branco text-texto hover:shadow-hover hover:text-marca",
        secondary: "bg-borda-suave text-texto hover:shadow-hover",
        ghost: "text-texto-2 hover:bg-borda-suave hover:text-texto",
        link: "text-marca underline-offset-4 hover:underline",
      },
      size: {
        default: "h-9 px-4 py-2",
        sm: "h-8 gap-1.5 px-3",
        lg: "h-10 px-6 text-14",
        icon: "size-9",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  },
);

function Button({
  className,
  variant,
  size,
  asChild = false,
  ...props
}: React.ComponentProps<"button"> &
  VariantProps<typeof buttonVariants> & {
    asChild?: boolean;
  }) {
  const Comp = asChild ? Slot : "button";

  return (
    <Comp data-slot="button" className={cn(buttonVariants({ variant, size, className }))} {...props} />
  );
}

export { Button, buttonVariants };
